// extracted by mini-css-extract-plugin
module.exports = {"validationPage":"_536846c"};